// extracted by mini-css-extract-plugin
export default {"center-vertically":"_center-vertically_oe1OxQ","menu":"_menu_0fqm4m","hidden":"_hidden_ib5WNQ"};